import * as React from 'react';

import { DeliveryPersonDTO, Permission, Res } from 'core/api';
import { Colors, Format } from 'core/ui';
import * as Images from '../Images';
import { SessionProvider } from 'core/infrastructure';
import { Table, Box, Image, HStack, Text, TableCellProps } from '@chakra-ui/react';
import { SvgIcon } from 'core/ui-next';



export default function DeliveryPersonStatusList(props: { deliveryPersons: DeliveryPersonDTO[], selected: Nullable<DeliveryPersonDTO>, onDeliveryPersonSelected: (deliveryPerson: DeliveryPersonDTO) => void }): React.ReactNode {
	return <Table.ScrollArea w={'full'} h={'full'} rounded={'md'}>
		<Table.Root size={'sm'} striped interactive stickyHeader>
			<Table.Header>
				<Table.Row>
					<Table.ColumnHeader fontWeight={'semibold'} textAlign={'start'} flex={1} minW={0}>{Res.Web.DELIVERY_PERSON_LIST_DELIVERY_PERSON_CLM()}</Table.ColumnHeader>
					<Table.ColumnHeader w={'26'} fontWeight={'semibold'} textAlign={'end'} hideBelow={'md'}>{Res.Web.DELIVERY_PERSON_LIST_DELIVERING_CLM()}</Table.ColumnHeader>
					<Table.ColumnHeader w={'25'} fontWeight={'semibold'} textAlign={'end'} hideBelow={'md'}>{Res.Web.DELIVERY_PERSON_LIST_DELIVERED_CLM()}</Table.ColumnHeader>
					{
						SessionProvider.hasPermission(Permission.DeliveryPerson_ShowStatus)
							? <Table.ColumnHeader w={'25'} fontWeight={'semibold'} textAlign={'end'} hideBelow={'md'}>{Res.Web.DELIVERY_PERSON_LIST_PENDING_BALANCE_CLM()}</Table.ColumnHeader>
							: null
					}
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{props.deliveryPersons.map((status) => {

					const cellBackGround: TableCellProps['bg'] = props.selected !== null && props.selected.UserId === status.UserId ? { base: '{colors.blue.200}', _dark: '{colors.blue.500}' } : undefined;
					return <Table.Row key={status.UserId} h={'9'} cursor={'pointer'} onClick={() => props.onDeliveryPersonSelected(status)}>
						<Table.Cell background={cellBackGround} flex={1} minW={0} paddingY={'1'}>
							<HStack>
								<Box
									minW={'7'}
									minH={'7'}
									width={'7'}
									height={'7'}
									hideBelow={'md'}
									background={status.UserImageId === Images.NULL_IMAGE ? Colors.getBackgroundColorAsRgb(status.UserBackColor) : 'inherit'}>
									{
										status.UserImageId !== Images.NULL_IMAGE
											? <Image src={Images.imgSrcFromId(status.UserImageId)} borderRadius={'full'} />
											: <SvgIcon src={Images.User} borderRadius={'full'} />
									}

								</Box>
								<Text fontSize={'sm'} lineClamp={1}>{status.UserName}</Text>
							</HStack>
						</Table.Cell>
						<Table.Cell background={cellBackGround} w={'26'} paddingY={'1'} textAlign={'end'} hideBelow={'md'}>{status.DeliveringOrders}</Table.Cell>
						<Table.Cell background={cellBackGround} w={'25'} paddingY={'1'} textAlign={'end'} hideBelow={'md'}>{status.DeliveredOrders}</Table.Cell>
						{
							SessionProvider.hasPermission(Permission.DeliveryPerson_ShowStatus)
								? <Table.Cell background={cellBackGround} w={'25'} paddingY={'1'} textAlign={'end'} hideBelow={'md'}>{Format.asMoney(status.Balance)}</Table.Cell>
								: null
						}
					</Table.Row>;
				})}
			</Table.Body>
		</Table.Root>
	</Table.ScrollArea >;
}
